export enum FeatureName {
  AUTH_DAPP = 'auth-dapp',
  UNITY_WEARABLE_PREVIEW = 'unity-wearable-preview',
  REFERRAL = 'show-referral',
  REFERRAL_TESTING_BUTTON = 'show-referral-testing-button'
}
